module.exports = __webpack_public_path__ + "static/img/US.4d1c398a.png";